export const skills: readonly string[] = [
  'Ruby',
  'Ruby on Rails',
  'React',
  'PostgreSQL',
  'Redis',
  'Kafka',
  'RabbitMQ',
  'NestJS',
  'Golang',
  'Rust',
];
